<template>
  <!-- <pre v-if="categoryStarCounts">
  {{ categoryStarCounts }}
</pre> -->

  <Background v-if="tandas">
    <div class="image-wrapper">
      <img
        src="@/assets/header/TANDAS AWAM PBT.png"
        alt="TANDAS AWAM PBT"
        class="pbt-image"
      />

      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>Pengauditan dan Penarafan Bintang Tandas Awam di PBT</h2>

      <div class="main-image-container">
        <img src="@/assets/tandas/tandas.png" alt="First Image" />
        <div class="main-number-overlay">
          {{ tandas.jumlah_tandas_diaudit }}
        </div>
      </div>

      <div class="tandas">
        <div class="tandas-container">
          <img src="@/assets/tandas/five.png" alt="Second Image" />
          <div class="number-overlay">
            {{ tandas["5_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/four.png" alt="Third Image" />
          <div class="number-overlay">
            {{ tandas["4_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/three.png" alt="Fourth Image" />
          <div class="number-overlay">
            {{ tandas["3_bintang"] }}
          </div>
        </div>

        <div class="tandas-container">
          <img src="@/assets/tandas/two.png" alt="Fifth Image" />
          <div class="number-overlay">
            {{ tandas["2_bintang"] }}
          </div>
        </div>
      </div>
      <Update />
    </div>
  </Background>
  <Menu />
</template>

<script setup>
import Background from "@/components/background/background.vue";
import Menu from "@/components/menu-items/utama-menu.vue";
import { onMounted, ref } from "vue";

definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
});

const responseTandasData = ref(null);
const tandas = ref({
  jumlah_tandas_diaudit: 0,
  "5_bintang": 0,
  "4_bintang": 0,
  "3_bintang": 0,
  "2_bintang": 0,
});

const categoryStarCounts = ref({});

const allowedCategories = [
  "Bangunan Kerajaan",
  "Hotel",
  "Tandas Awam PBT",
  "Terminal Pengangkutan Awam",
  "Bangunan-bangunan Komersial",
  "Hentian Sebelah / Kawasan R&R",
  "Pasar Awam",
  "Pintu Masuk Utama Negara",
  "Pusat Beli-belah",
  "IPTA / IPTS",
  "Pusat Peranginan / Pelancongan",
  "Restoran dan Premis Makanan",
  "Rumah Ibadat",
  "Sekolah",
  "Stesen Minyak",
  "Taman Rekreasi",
];

async function loadDataFromApi() {
  try {
    const token = "17535|MqnzNqNSM3JpAH2k5QCxq21fNVhC9MZJZ7lVPte33cd13ffb";

    const response = await fetch(
      "https://mywc.kpkt.gov.my/api/integration/get-toilet-list",
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const data = await response.json();
    responseTandasData.value = data;

    const toiletList = data.data || [];

    // ✅ Filter & deduplicate by premise_name
    // ✅ Unique by both name and average_star
    const premiseMap = {};

    toiletList.forEach((toilet) => {
      if (
        toilet.premise_name &&
        allowedCategories.includes(toilet.premise_category) &&
        toilet.average_star != null &&
        toilet.average_star > 0
      ) {
        const key = `${toilet.premise_name}_${toilet.average_star}`;
        if (!premiseMap[key]) {
          premiseMap[key] = {
            average_star: toilet.average_star,
            category: toilet.premise_category,
          };
        }
      }
    });

    const categoryCount = {
      "2_bintang": 0,
      "3_bintang": 0,
      "4_bintang": 0,
      "5_bintang": 0,
    };

    const perCategoryBreakdown = {};

    Object.entries(premiseMap).forEach(([_, { average_star, category }]) => {
      const rounded = Math.round(average_star);
      const key = `${rounded}_bintang`;

      if (!perCategoryBreakdown[category]) {
        perCategoryBreakdown[category] = {
          "2_bintang": 0,
          "3_bintang": 0,
          "4_bintang": 0,
          "5_bintang": 0,
        };
      }

      if (categoryCount[key] !== undefined) {
        categoryCount[key]++;
      }

      if (perCategoryBreakdown[category][key] !== undefined) {
        perCategoryBreakdown[category][key]++;
      }
    });

    tandas.value = {
      jumlah_tandas_diaudit:
        categoryCount["2_bintang"] +
        categoryCount["3_bintang"] +
        categoryCount["4_bintang"] +
        categoryCount["5_bintang"],
      ...categoryCount,
    };

    categoryStarCounts.value = perCategoryBreakdown;
  } catch (err) {
    console.error("loadDataFromApi failed:", err);
  }
}

onMounted(() => {
  loadDataFromApi();
});
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%);
  border-radius: 20px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%;
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px;
  text-align: left;
  width: 100%;
  text-transform: uppercase;
}

.main-image-container {
  position: relative;
  display: inline-block;
}

.main-number-overlay {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px 20px;
  border-radius: 5px;
}

.tandas {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  margin-top: 10px;
}

.tandas-container {
  position: relative;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
}

.tandas-container img {
  border-radius: 10px;
}

.number-overlay {
  position: absolute;
  top: 50%;
  left: 90%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px;
  border-radius: 5px;
}

@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .main-number-overlay {
    font-size: 2.5rem;
  }

  .tandas {
    grid-template-columns: 1fr;
  }

  .number-overlay {
    font-size: 1.8rem;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 1.2rem;
  }

  .main-number-overlay {
    font-size: 2rem;
  }

  .number-overlay {
    font-size: 1.5rem;
  }
}
</style>
